import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {ActionBox} from 'shells/action-box/action-box';
import {WarningIcon} from 'shells/action-box/action-icons';
import {Link} from 'shells/link/link';

type Props = {
    canAccessSetup: boolean;
};

export function CustomClickDomainActionBox(props: Props) {
    return (
        <ActionBox
            title='Custom Click Domain'
            subtitle={
                'DNS records for your custom click domain are not configured. The default click domain will be used instead.'
            }
            icon={<WarningIcon />}
            actionElement={
                props.canAccessSetup ? (
                    // @ts-expect-error
                    <Link variant='primary' to='/setup/domains' as={RoutedLink}>
                        Configure
                    </Link>
                ) : undefined
            }
        />
    );
}
